import { useEffect } from 'react';
import { getMyPermVersion } from '../api/permissionsApi';
import { startPermSync } from '../lib/permSync';
import { usePermissionStore } from '../store/permissionStore';

/** INTRO-17: keeps the permission document current while the person is signed
 *  in, so a purpose approved or ended by someone else shows up in seconds.
 *  See lib/permSync.ts for how and why. */
export function usePermSync(userId: string | undefined): void {
  useEffect(() => {
    if (!userId) return undefined;
    const store = usePermissionStore;
    return startPermSync({
      fetchVersion: getMyPermVersion,
      getVersion: () => store.getState().effective?.perm_version,
      refresh: () => store.getState().refreshEffective(),
      getExpiries: () => (store.getState().effective?.purposes ?? [])
        .map((p) => p.expires_at).filter((e): e is string => !!e),
      subscribe: (listener) => store.subscribe((state, prev) => {
        if (state.effective !== prev.effective) listener();
      }),
    });
  }, [userId]);
}
